import request from '@/utils/axios'
import qs from 'qs'

export function getLocationAndClasstype(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/getLocationAndClasstype',
        method: 'post',
        data: postData
    })
}

export function addLocationAndClasstype(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/addLocationAndClasstype',
        method: 'post',
        data: postData
    })
}

export function editLocationAndClasstype(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/editLocationAndClasstype',
        method: 'post',
        data: postData
    })
}

export function deleteLocationAndClasstype(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/deleteLocationAndClasstype',
        method: 'post',
        data: postData
    })
}

export function getCoursePackageIdsByLocationAndClasstypeId(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/getCoursePackageIdsByLocationAndClasstypeId',
        method: 'post',
        data: postData
    })
}

export function addLocationAndClasstypeAndCoursepackage(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/addLocationAndClasstypeAndCoursepackage',
        method: 'post',
        data: postData
    })
}

export function getCoursepackagesByLocationIdAndClasstypeId(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationAndClasstypeAndCoursePackage/getCoursepackagesByLocationIdAndClasstypeId',
        method: 'post',
        data: postData
    })
}